(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sheer-editorial-stage"] && !Shopify.designMode) return;
  try {
    function svStartEditorialFilms(root = document) {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  root.querySelectorAll('.sv-editorial-stage__video').forEach(video => {
    if (video.dataset.svFilmReady) return;
    video.dataset.svFilmReady = 'true';
    video.muted = true;
    video.playsInline = true;
    let manuallyPaused = false;
    video.addEventListener('pause', () => { if (video.dataset.svAutomaticPause !== 'true') manuallyPaused = true; });
    video.addEventListener('play', () => { delete video.dataset.svAutomaticPause; });
    const pause = () => { video.dataset.svAutomaticPause = 'true'; video.pause(); };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !reduced.matches && !manuallyPaused && !document.hidden) video.play().catch(() => {});
        else pause();
      });
    }, { threshold: .25 });
    observer.observe(video);
    reduced.addEventListener('change', () => { if (reduced.matches) pause(); });
    document.addEventListener('visibilitychange', () => { if (document.hidden) pause(); });
  });
}
svStartEditorialFilms();
document.addEventListener('shopify:section:load', event => svStartEditorialFilms(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-emblem-banner"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.sv-emblem__play').forEach(button => {
  button.addEventListener('click', () => {
    const media = button.closest('.sv-emblem__media');
    const video = media.querySelector('video');
    if (!video.paused) {
      video.pause();
      button.textContent = '\u25b6';
      button.setAttribute('aria-label', button.dataset.playLabel);
    } else {
      video.muted = true;
      video.play().then(() => {
        media.classList.add('is-playing');
        button.textContent = '\u2161';
        button.setAttribute('aria-label', button.dataset.pauseLabel);
      }).catch(() => {});
    }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sv-study-banner"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.sv-study__play').forEach(button => {
  button.addEventListener('click', () => {
    const media = button.closest('.sv-study__media');
    const video = media.querySelector('video');
    video.play().then(() => {media.classList.add('is-playing');}).catch(() => {});
  });
});
  } catch(e) { console.error(e); }
})();

})();
